import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  serviceBase = environment.baseUrl;

  constructor(
    protected http: HttpClient
  ) {
  }

  serverName$ : Observable<any> = this.http.get(`${this.serviceBase}/home/webserver`);
}